module.exports = __webpack_public_path__ + "static/media/botanacor-logo.b1ffde47.svg";